var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/Dot",
    transform: "translate(-3.000000, -4.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75,12.25 C5.7125,12.25 6.5,13.0375 6.5,14 C6.5,14.9625 5.7125,15.75 4.75,15.75 C3.7875,15.75 3,14.9625 3,14 C3,13.0375 3.7875,12.25 4.75,12.25 Z M15.25,12.25 C16.2125,12.25 17,13.0375 17,14 C17,14.9625 16.2125,15.75 15.25,15.75 C14.2875,15.75 13.5,14.9625 13.5,14 C13.5,13.0375 14.2875,12.25 15.25,12.25 Z M10,4 C10.9625,4 11.75,4.7875 11.75,5.75 C11.75,6.7125 10.9625,7.5 10,7.5 C9.0375,7.5 8.25,6.7125 8.25,5.75 C8.25,4.7875 9.0375,4 10,4 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.ad281a1c7d2f91762bedf7e2a5f9ee96.svg";
export { ForwardRef as ReactComponent };